import React from "react";
import { useState } from "react";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Container,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Navbar from "./Navbar";
import { Link, useNavigate } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import logo from "../images/image_10.png";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const LoginUpdated = () => {
  let navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [backopen, setBackopen] = useState(false);
  const LoaderClose = () => {
    setBackopen(false);
  };
  const LoaderOpen = () => {
    setBackopen(true);
  };
  // const [user, setUser] = useState({ email: "", password: "" });
  const [email ,setEmail] = useState(localStorage.getItem("email"));
  const [password,setPassword] = useState("");
  function userd(){
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/IMI-backend/new-data.php`,
      data: {
          type: 'get_user_basic_details',
          user_id:localStorage.getItem("user_id")
          
        }
    })
      .then(function (response) {
        console.log(response.data.data,"user")
        localStorage.setItem("currentStep", response.data.data.current_step_count);
        localStorage.setItem("currentStepStatus", response.data.data.current_step_status);
        localStorage.setItem("firstname", response.data.data.firstname);
        localStorage.setItem("mobile", response.data.data.mobile);
        localStorage.setItem("category", response.data.data.category);
        if(response.data.data.lastname.split(" ").length>1){
          localStorage.setItem("lastname", response.data.data.lastname.split(" ")[1]);
          localStorage.setItem("middlename", response.data.data.lastname.split(" ")[0]);
        }
        else{
          localStorage.setItem("lastname", response.data.data.lastname);
        }
        if(response.data.data.category == 12){
          navigate('/SMform')
        }else{
          navigate('/form')
        }
      })
    // if(program_choosen==38){
      
    // }
    // else{
    //   axios({
    //     method: 'post',
    //     url: `${process.env.REACT_APP_BASE_URL}/xlri-backend/data.php`,
    //     data: {
    //         type: 'get_user_basic_details',
    //         user_id:localStorage.getItem("user_id")
            
    //       }
    //   })
    //     .then(function (response) {
    //       // console.log(response.data,"user")
    //       localStorage.setItem("firstname",response.data.firstname)
    //       localStorage.setItem("lastname",response.data.lastname)
    //       if(response.data.program_id == 39){
    //         navigate('/GMform')
    //       }else{
    //         navigate('/form')
    //       }
    //       axios({
    //         method: 'post',
    //         url: `${process.env.REACT_APP_BASE_URL}/xlri-backend/data.php`,
    //         data: {
    //             type: 'update_payment_status',
    //             user_id:localStorage.getItem("user_id")
    //           }
    //       }).then((response)=>{
    //         console.log(response)
    //       })
    //     })
    // }
    
  
  }
  const handleChange = (e) => {
    setEmail(e.target.value);
  
  };
  const handleChangepassword = (e) => {
 
    setPassword(e.target.value);
  };

  const removeSpace=(pass)=>{
    const originalString = pass;
const reducedString = originalString.replace(/\s+/g, '');

return reducedString; // Output: 'ABCD'
  }

  // console.log(password,removeSpace(password),password.length,removeSpace(password).length,"pass")
  const submitForm = (e) => {
    if (email && password) {
      LoaderOpen();
      e.preventDefault();
      axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/IMI-backend/wpdata-new.php`,
        data: {
          type: "imi_login_up",
          username: email,
          password: removeSpace(password),
        },
      }).then(function (response) {
        LoaderClose();
        console.log(response);
        if (response.data[0].status == 200) {
         
          localStorage.setItem("user_id", response.data[0].user_id);
          localStorage.setItem("email", response.data[0].email);
          
          userd();
          // axios({
          //   method: "post",
          //   url: `${process.env.REACT_APP_BASE_URL}/IITG-backend/data.php`,
          //   data: {
          //     type: "update_payment_status",
          //     user_id: localStorage.getItem("user_id"),
          //   },
          // }).then((response) => {
          //   console.log(response);
          // });
          
         
        } else if (response.data[0].status == 400) {
          toast.error("Enter the valid email or password", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error("Enter the valid email or password", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      });
    } else {
      toast.error("Please enter the required fields", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <>
      <Navbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Box sx={{display:{xs:"none",lg:"block"}}}>
      <Box

      >
        <Grid container>
        {/* <Grid item lg={3}>
            <Box sx={{ ml: 7, mt: 3 }}>
              <Box sx={{ mb: 2 }}>
                <Typography
                  sx={{
                    color: "#000",
                    fontWeight: "bold",
                    fontSize: "28px",
                    width: 491,
                    textAlign: "left",
                  }}
                >
                  Online certifications from a NIRF #34 ranked Management College
                </Typography>
              </Box>
              <Box
                sx={{
                  borderRadius: "6px",
                
                  background: "linear-gradient(#002E5C,#2A7BCC)",
                  width: 400,
                  px:4,
                  py:1
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "31px",
                    width: 430,
                    textAlign: "left",
                  }}
                >
                Executive Program in
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "32px",
                    width: 430,
                    textAlign: "left",
                  }}
                >
              Strategic HR Analytics and

                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "32px",
                    width: 430,
                    textAlign: "left",
                  }}
                >
            Sales & Marketing

                </Typography>
              </Box>
            </Box>
          </Grid> */}
          <Grid item lg={9}>
            <Box sx={{ pt: 10, ml: 45 }}>
              <Container fixed>
                <Box>
                  <Box>
                    <Grid container spacing={9} justifyContent="center">
                      <Grid item lg={8} sx={{ pb: 4 }}>
                        <Paper
                          elevation={3}
                          sx={{
                            boxShadow: "0 0 1rem 0 rgba(0, 0, 0, .2)",
                            borderRadius: "15px",
                            backgroundColor: "#fff",

                            //  backdropFilter: "blur(5px)",
                            //  border:"1px solid #fdb714",
                            p: 2,
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                textAlign: "center",
                                fontWeight: "bold",
                                color: "#002E5C",
                                fontSize: "27px",
                              }}
                            >
                              Login
                            </Typography>
                            <hr
                              style={{
                                backgroundColor: "#000",
                                border: "none",
                                height: "1.3px",
                                width: "90%",
                              }}
                            />
                          </Box>
                          <Box sx={{ mx: 2, py: 2 }}>
                            <form onSubmit={submitForm}>
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#000",
                                  textAlign: "left",
                                }}
                              >
                                Email<span style={{ color: "red" }}>*</span>
                              </Typography>
                              <TextField
                                id="email"
                                size="small"
                                type="email"
                                name="email"
                                fullWidth
                                required
                                defaultValue={localStorage.getItem("email")}
                                sx={{
                                  mb: 2,
                                  background: "#D9D9D9",
                                  borderRadius: "4px",
                                }}
                                onChange={handleChange}
                                // value={localStorage.getItem("email")}
                              />
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#000",
                                  textAlign: "left",
                                }}
                              >
                                Password <span style={{ color: "red" }}>*</span>
                              </Typography>
                              <FormControl sx={{ mb: 2 }} fullWidth>
                                {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                                <OutlinedInput
                                  size="small"
                                  name="password"
                                  required
                                  onChange={handleChangepassword}
                                  value={password}
                                  sx={{
                                    background: "#D9D9D9",
                                    borderRadius: "4px",
                                  }}
                                  id="outlined-adornment-password"
                                  type={showPassword ? "text" : "password"}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                      >
                                        {showPassword ? (
                                          <VisibilityOff />
                                        ) : (
                                          <Visibility />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                  label="Password"
                                />
                              </FormControl>
                              <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                  background: "#002E5C",
                                  color: "#fff",
                                  textTransform: "none",
                                  fontSize: "17px",
                                  fontWeight: "bold",
                                  "&:hover": {
                                    background: "#002E5C",
                                    color: "#fff",
                                  },
                                }}
                                type="submit"
                              >
                                Login
                              </Button>
                            </form>
                            <Box
                              sx={{
                                mt: 2,
                               
                              
                              }}
                            >
                              <a
                                style={{
                                  marginTop: "10px",
                                  // marginLeft: "8px",
                                  color: "#000",
                                  fontWeight: "bold",
                               paddingBottom:"10px"
                                }}
                                href="https://www.accredian.com/my-account/lost-password/"
                                target="blank"
                              >
                                Forgot Password
                              </a>
                              <Typography sx={{mt:2}}>Don't have account?
                              <Link
                                style={{
                                  marginTop: "7px",
                                  marginLeft: "10px",
                                  color: "red",
                                  fontWeight: "bold",
                                }}
                                to="/"
                              >
                                Sign Up
                              </Link>
                              </Typography> 
                            </Box>
                          </Box>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Container>
            </Box>
          </Grid>
        </Grid>
      </Box>

      </Box>

      {/* mobile version */}
      <Box sx={{display:{xs:"block",lg:"none"}}}>
      <Box
     
      >
        <Grid container>
          {/* <Grid item lg={3}>
            <Box sx={{ ml: 4, mt: 3 }}>
              <Box sx={{ mb: 1 }}>
                <Typography
                  sx={{
                    color: "#000",
                    fontWeight: "bold",
                    fontSize: "21px",
                    width: 300,
                    textAlign: "left",
                  }}
                >
                  Online certifications from a NIRF #34 ranked Management College
                </Typography>
              </Box>
              <Box
                sx={{
                  borderRadius: "6px",
                  p: 1,
                  background: "linear-gradient(#002E5C,#2A7BCC)",
                  width: 290,
                }}
              >
                <Typography
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "24px",
                    width: 280,
                    textAlign: "left",
                  }}
                >
                  Executive Program in 
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "24px",
                    width: 280,
                    textAlign: "left",
                  }}
                >
                 Strategic HR Analytics and Sales & Marketing
                </Typography>
              </Box>
            </Box>
          </Grid> */}
          <Grid item lg={9}>
            <Box sx={{ pt: 3 }}>
              <Container fixed>
                <Box>
                  <Box>
                    <Grid container spacing={9} justifyContent="center">
                      <Grid item lg={8} sx={{ pb: 4 }}>
                        <Paper
                          elevation={3}
                          sx={{
                            boxShadow: "0 0 1rem 0 rgba(0, 0, 0, .2)",
                            borderRadius: "15px",
                            backgroundColor: "#fff",

                            //  backdropFilter: "blur(5px)",
                            //  border:"1px solid #fdb714",
                            p: 2,
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                textAlign: "center",
                                fontWeight: "bold",
                                color: "#002E5C",
                                fontSize: "27px",
                              }}
                            >
                              Login
                            </Typography>
                            <hr
                              style={{
                                backgroundColor: "#000",
                                border: "none",
                                height: "1.3px",
                                width: "90%",
                              }}
                            />
                          </Box>
                          <Box sx={{ mx: 2, py: 2 }}>
                            <form onSubmit={submitForm}>
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#000",
                                  textAlign: "left",
                                }}
                              >
                                Email<span style={{ color: "red" }}>*</span>
                              </Typography>
                              <TextField
                                id="email"
                                size="small"
                                type="email"
                                name="email"
                                fullWidth
                                defaultValue={localStorage.getItem("email")}
                                required
                                sx={{
                                  mb: 2,
                                  background: "#D9D9D9",
                                  borderRadius: "4px",
                                }}
                                onChange={handleChange}
                                // value={localStorage.getItem("email")}
                              />
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#000",
                                  textAlign: "left",
                                }}
                              >
                                Password <span style={{ color: "red" }}>*</span>
                              </Typography>
                              <FormControl sx={{ mb: 2 }} fullWidth>
                                {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                                <OutlinedInput
                                  size="small"
                                  name="password"
                                  required
                                  onChange={handleChangepassword}
                                  value={password}
                                  sx={{
                                    background: "#D9D9D9",
                                    borderRadius: "4px",
                                  }}
                                  id="outlined-adornment-password"
                                  type={showPassword ? "text" : "password"}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                      >
                                        {showPassword ? (
                                          <VisibilityOff />
                                        ) : (
                                          <Visibility />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                  label="Password"
                                />
                              </FormControl>
                              <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                  background: "#002E5C",
                                  color: "#fff",
                                  textTransform: "none",
                                  fontSize: "17px",
                                  fontWeight: "bold",
                                  "&:hover": {
                                    background: "#002E5C",
                                    color: "#fff",
                                  },
                                }}
                                type="submit"
                              >
                                Login
                              </Button>
                            </form>
                            <Box
                              sx={{
                                mt: 2,
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <a
                                style={{
                                  marginTop: "7px",
                                  // marginLeft: "8px",
                                  color: "#000",
                                  fontWeight: "bold",
                                }}
                                href="https://www.accredian.com/my-account/lost-password/"
                                target="blank"
                              >
                                Forgot Password
                              </a>
                          
                              <Link
                                style={{
                                  marginTop: "7px",
                                  marginLeft: "10px",
                                  color: "red",
                                  fontWeight: "bold",
                                }}
                                to="/"
                              >
                                Sign Up
                              </Link>
                            </Box>
                          </Box>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Container>
            </Box>
          </Grid>
        </Grid>
      </Box>


      </Box>
          </>
  );
};
export default LoginUpdated;
